import React from 'react';
import {
  Box,
  Button,
  HeadingText,
  ParagraphText,
  StackLayout,
} from '@leagueplatform/genesis-core';
import { useIntl } from '@leagueplatform/locales';
import ErrorIllustration from '../../assets/error-illustration.svg';

interface GenericErrorScreenProps {
  onButtonClick: () => void;
  title?: string;
  description?: string;
  buttonText?: string;
}

export const GenericErrorScreen = ({
  onButtonClick,
  title,
  description,
  buttonText,
}: GenericErrorScreenProps) => {
  const { formatMessage } = useIntl();

  const resolvedTitle =
    title ?? formatMessage({ id: 'STR_ERROR_STATE_HEADING_GENERIC' });
  const resolvedDescription =
    description ?? formatMessage({ id: 'STR_ERROR_STATE_BODY_API' });
  const resolvedButtonText = buttonText ?? formatMessage({ id: 'STR_RELOAD' });

  return (
    <Box
      css={{
        minHeight: '100vh',
        background: '$surfaceBackgroundSecondary',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        padding: '$two',
      }}
    >
      <Box
        css={{
          width: '708px',
          maxWidth: '100%',
          marginInline: 'auto',
          background: '$surfaceCardSecondary',
          boxShadow: '$card',
          borderRadius: '$medium',
        }}
      >
        <StackLayout
          spacing="$twoAndHalf"
          horizontalAlignment="stretch"
          css={{
            paddingBlock: '$twoAndHalf',
            paddingInline: '$twoAndHalf',
          }}
        >
          <Box
            as="img"
            src={ErrorIllustration}
            alt=""
            width={176}
            height={176}
            css={{ display: 'block', marginInline: 'auto' }}
          />

          <StackLayout spacing="$half" horizontalAlignment="center">
            <HeadingText
              size="lg"
              level="2"
              as="h1"
              css={{ textAlign: 'center' }}
            >
              {resolvedTitle}
            </HeadingText>
            <ParagraphText
              css={{ textAlign: 'center', color: '$onSurfaceTextSubdued' }}
            >
              {resolvedDescription}
            </ParagraphText>
          </StackLayout>

          <Button
            type="button"
            size="large"
            priority="primary"
            width="fillContainer"
            onClick={onButtonClick}
          >
            {resolvedButtonText}
          </Button>
        </StackLayout>
      </Box>
    </Box>
  );
};
